export function wrapEmailTemplate(body) {
  return `<html>
    <body>
      <div style="margin:0;padding:0;">
        <table role="presentation"
          style="width:100%;border-collapse:collapse;border:0;border-spacing:0;background:#ffffff;">
          <tr>
            <td align="center" style="padding:0;">
              <table role="presentation"
                style="width:602px;border-collapse:collapse;border:1px solid #cccccc;border-spacing:0;text-align:left;">
                <tr>
                  <td align="center" style="padding:20px 0 20px 0;background:#244c94;">
                    <img src="https://sitioinstituionalqa.blob.core.windows.net/strapi-qa/strapi-qa/assets/unnamed_c53dd6d1ab.png" alt=""
                      width="120" style="height:50;display:block; width: 70%;" />
                  </td>
                </tr>
                <tr>
                  <td style="padding:36px 30px 42px 30px;">
                    ${body}
                  </td>
                </tr>
                <tr>
                  <td style="padding:30px;background:#244c94;">
                    <table role="presentation"
                      style="width:100%;border-collapse:collapse;border:0;border-spacing:0;font-size:9px;font-family:Arial,sans-serif;">
                      <tr>
                        <td style="padding:0;width:50%;" align="center">
                          <table role="presentation"
                            style="border-collapse:collapse;border:0;border-spacing:0;">
                            <tr>
                              <td style="padding:0 0 0 10px;width:38px;">
                                <a href="https://www.linkedin.com/company/hospital-brit-nico-buenos-aires" style="color:#ffffff;"><img
                                    src="https://almacenamientosvarioshb.blob.core.windows.net/imagenes/Linkedin.png"
                                    alt="LinkedIn" width="30"
                                    style="height:auto;display:block;border:0;" /></a>
                              </td>
                              <td style="padding:0 0 0 10px;width:38px;">
                                <a href="https://www.facebook.com/HospitalBritanicoPlanDeSalud" style="color:#ffffff;"><img
                                    src="https://almacenamientosvarioshb.blob.core.windows.net/imagenes/facebook.png"
                                    alt="Facebook" width="30"
                                    style="height:auto;display:block;border:0;" /></a>
                              </td>
                              <td style="padding:0 0 0 10px;width:38px;">
                                <a href="https://www.instagram.com/plandesaludhb" style="color:#ffffff;"><img
                                    src="https://almacenamientosvarioshb.blob.core.windows.net/imagenes/instagram.png"
                                    alt="Instagram" width="30"
                                    style="height:auto;display:block;border:0;" /></a>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </div>
    </body>
  </html>`;
}
